import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router preserves scroll position across route changes by default, so
// navigating from a scrolled-down page (e.g. SIT Run History at the bottom of
// the list, or the Agent Studio form past the fold) to another route leaves
// the next page starting mid-screen. Mount this once inside each <Router> in
// App.js; whenever the pathname changes, scroll resets to the top.
//
// Implementation notes (corrected from the original PR):
//   - useLayoutEffect (not useEffect) so the scroll fires synchronously
//     BEFORE the browser paints the new route. Avoids the "visible jump"
//     where the user sees the previous scroll position for a frame.
//   - Positional args window.scrollTo(0, 0) instead of
//     { behavior: 'instant' }. Some browsers silently treat 'instant' as
//     'smooth' (or ignore it), producing a visible animated scroll — which
//     is exactly the "page auto-scrolls" symptom users were reporting.
//     Positional form is universally supported and always instant.
//
// Intentionally does NOT fire on location.state changes — intra-page actions
// (e.g. opening a modal, expanding a card) shouldn't yank the user back to
// the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
